import  {Routes, Route} from 'react-router-dom';
import './App.css';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import Cart from './Components/Cart'
import About from './Components/About';
import Products from './Components/Products';
import Product from './Components/Product';
import Contact from './Components/Contact';

function App() {
  return (
    <>
    <Navbar/>
    <Routes>
<Route  path='/' element={<Home/>}/>
<Route path='/products' element={<Products/>} />
<Route path='/products/:id' element={<Product/>} />
<Route path='/cart' element={<Cart/>} />
<Route path = '/about' element={<About/>}/>
<Route path="/contact" element={<Contact/>}/>
{/* 
<Route path="/register" component={Register} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/cart" component={Cart} /> */}


    </Routes>
    </>
  )
}

export default App;
